<ng-container *transloco="let t">
    <div
        #reference
        *ngIf="!isOpen"
        class="tms-map-button-solo"
    >
        <bazis-button
            fill="clear"
            (click)="isOpen = true"
        >
            <bazis-icon
                slot="icon-only"
                name="search"
            ></bazis-icon>
        </bazis-button>
        <bazis-tooltip
            [reference]="reference"
            placement="left"
            class="bh-popper-z-index"
            [isStatic]="true"
            [offset]="[-12, 0]"
            [arrow]="false"
            >{{ t('map.tooltip.search') }}</bazis-tooltip
        >
    </div>
    <bazis-input-default
        *ngIf="isOpen"
        [style.--control-width]="'524px'"
        [formControl]="searchControl"
        [placeholderKey]="'map.placeholder.search'"
        leftIcon="search"
        rightIcon="cross"
        [isRightIconClickable]="true"
        sizeControl="large"
        [hasEraser]="false"
        (rightIconClick)="clearAndClose()"
    ></bazis-input-default>

    <!-- <bazis-infinite-list
        [searchSettings]="searchSettings"
        [emptyValue]="emptyValueEntity"
        [excludeIds$]="excludeIds$"
        emptyListKey="title.emptySearch"
        [search$]="searchControl.valueChanges"
    >
        <ng-template let-item="item">
            <div
                class="bazis-item"
                [class.bazis-item--selected]="
                    valuesMap &&
                    valuesMap.has(
                        searchSettings.fieldForId
                            ? item.$snapshot[searchSettings.fieldForId]?.id
                            : item.id
                    )
                "
                (click)="
                    toggleValue(
                        searchSettings.fieldForId
                            ? item.$snapshot[searchSettings.fieldForId]?.id
                            : item.id
                    )
                "
            >
                <ng-container
                    *ngIf="infiniteListTpl"
                    [ngTemplateOutlet]="infiniteListTpl"
                    [ngTemplateOutletContext]="{ item: item }"
                ></ng-container>
                <ng-container *ngIf="!infiniteListTpl">
                    {{
                        item.$snapshot.name ||
                            item.$snapshot[nameField] ||
                            t(item.$snapshot.nameKey)
                    }}
                </ng-container>
            </div>
        </ng-template>
    </bazis-infinite-list> -->
</ng-container>
